import React from 'react';
import PropTypes from 'prop-types';
import * as colors from '@constants/colors';

// Replaces transitions.easeOut('1s', 'left')
// isRtl is always false in this project
const easeOutTransition = 'left 1s cubic-bezier(0.23, 1, 0.32, 1) 0ms';

const InkBar = ({ color, left, style, width }) => {
  // inkBar.backgroundColor -> colors.dotmapsBlue (default MUI ink bar color)
  const rootStyle = {
    left,
    width,
    bottom: 0,
    display: 'block',
    backgroundColor: color || colors.dotmapsBlue,
    height: 2,
    marginTop: -2,
    position: 'relative',
    transition: easeOutTransition,
    ...style
  };

  return <div style={rootStyle} />;
};

InkBar.propTypes = {
  color: PropTypes.string,
  left: PropTypes.string.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: PropTypes.object,
  width: PropTypes.string.isRequired
};

export default InkBar;
